import { ADD_TO_CART_ERROR, ADD_TO_CART_REQUEST, ADD_TO_CART_SUCCESS, } from '../types';
import { getOrLoadCart } from './get-or-load-cart';
import { useHelper } from '../helpers';
export const addToCartRequest = () => {
    return {
        type: ADD_TO_CART_REQUEST,
    };
};
export const addToCartSuccess = ({ cart, product, quantity, sku }) => {
    return {
        type: ADD_TO_CART_SUCCESS,
        data: cart,
        product,
        quantity,
        sku,
    };
};
export const addToCartError = (error, meta = {}) => {
    return {
        type: ADD_TO_CART_ERROR,
        error: true,
        meta,
        payload: error,
    };
};
export const addToCart = (items) => async (dispatch, getState, { chord }) => {
    const { withCart } = useHelper(dispatch, getState);
    const dispatchAddToCartSuccess = (cart, item) => {
        dispatch(addToCartSuccess({
            cart,
            product: item.product,
            quantity: item.quantity,
            sku: item.sku,
        }));
    };
    try {
        const isSingleItem = !Array.isArray(items);
        dispatch(addToCartRequest());
        if (isSingleItem) {
            await withCart(chord.oms.addLineItem)(null, items);
            const updatedCart = await withCart(chord.oms.getOrder)();
            dispatchAddToCartSuccess(updatedCart, items);
            return updatedCart;
        }
        const { data } = await getOrLoadCart(dispatch, getState);
        const updatedCart = await withCart(chord.oms.updateOrder)(null, {
            id: data.id,
            lineItemsAttributes: items,
        });
        items.forEach((i) => dispatchAddToCartSuccess(updatedCart, i));
        return updatedCart;
    }
    catch (error) {
        dispatch(addToCartError(error, items));
        throw error;
    }
};
